import { BaseService } from "mrb/core";
import { CertifiedModeApiRouteService } from "common/services";

class CertifiedModeService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new CertifiedModeApiRouteService());
    }
    find(filter, abortSignal = null) {
        const url = this.routeService.find(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    get(id, options = {}, abortSignal = null) {
        const url = this.routeService.get(id, options);
        return this.apiClient.get(url, null, abortSignal);
    }
}

export default CertifiedModeService;
